module.exports = __webpack_public_path__ + "static/media/A2.5006c443.jpg";